<template>
  <div
    @click="$emit('click')"
    class="map-tool"
    id="view-type-button"
    :class="'elevation-5'"
  >
    <SatelliteSVG class="mapTypePickerSVG" v-if="!viewIsAerial" />
    <MapSVG class="mapTypePickerSVG" v-else />
    <md-tooltip class="app-tooltip" md-direction="bottom">
      {{ $t("ChangeViewType") }}
    </md-tooltip>
  </div>
</template>

<script>
import SatelliteSVG from "@/assets/map_icons/satellite.svg";
import MapSVG from "@/assets/map_icons/map.svg";

export default {
  name: "ChangeMapTypeButton",

  components: {
    SatelliteSVG,
    MapSVG
  },

  props: {
    /**
     * Determines whether the map view is Aerial or not
     */
    viewIsAerial: {
      type: Boolean,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Atoms/ChangeMapTypeButton.vue